import { FC } from "react";
import { FormFieldProps } from "../../../utils/formFields";
import useStyles from "../../../components/common/model/styles";
import { Grid, InputLabel } from "@mui/material";

const FormTitleField: FC<FormFieldProps> = (props) => {
  const classes = useStyles();
  return (
    <>
      <Grid
        item
        xs={12}
        sm={props?.md ? props?.md : 1.5}
        className={props?.label ? classes.titleBox :''}
        sx={{ marginTop: props?.isNonMarginTop ? "0px !important" : "",borderRadius:'5px',background:props?.label ?'#fafafa':'' }}
      >
        {props?.label ? (
          <InputLabel
            sx={{
              paddingBottom:'0px',
              lineHeight:1.5,
              color: "#000000",
              fontWeight: 700,
              fontSize: "30px",
              textAlign: "center",
              transformOrigin:'center !important',
              textTransform:'uppercase'
            }}
            shrink
            htmlFor={props?.id}
          >
          {props?.label}
          </InputLabel>
        ) : (
          ""
        )}
      </Grid>
    </>
  );
};
export default FormTitleField;
